(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name FavoritsController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('FavoritsController', FavoritsController);

    FavoritsController.$inject = ["$timeout","debugService","userService","autorService","espaiService","rutaService"];

    function FavoritsController($timeout,debugService,userService,autorService,espaiService,rutaService)
    {
    	var vm = this;
    	vm.user = userService;
        vm.espais = espaiService;
        vm.rutas = rutaService;
        vm.autors = autorService;
        vm.tabs = {
            espai:true,
            rutes:false,
            autors:false,
            centre:false
        };

        vm.changeTab = function(tab)
        {
            vm.tabs.espai = false;
            vm.tabs.rutes = false;
            vm.tabs.autors = false;
            vm.tabs.centre = false;
            if(tab=='espai')
                vm.tabs.espai=true;
            if(tab=='rutes')
                vm.tabs.rutes=true;
            if(tab=='autors')
                vm.tabs.autors=true;
            if(tab=='centre')
                vm.tabs.centre=true;
            
            return true;
        };
    }

})();